import { BreakPointCondition, UI, useBreakpointIf, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { customersAssetsDateSelected } from '../../../../store/customerDetail/atom';
import { IInvestedAssetsNormalized } from '../../../../store/customerDetail/types';

export interface AssetCardProps {
  product: IInvestedAssetsNormalized;
}

export const AssetCard: React.FC<AssetCardProps> = ({ product }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const selectedDate = useRecoilValue(customersAssetsDateSelected);

  if (isMobile) {
    return (
      <UI.Shadow level={1} borderRadius="8px" p={Spacing['inset.xs']}>
        <VStack space={Spacing['stack.xxxs']}>
          <HStack space={Spacing['inline.xxxs']} alignItems="center">
            <UI.CircularPercentage
              loading={false}
              data={[{ color: product.colorNormalized, percentage: product.percentageNormalized }]}
              size={60}
              textProps={{
                color: 'neutral.black',
                fontFamily: 'fontfamily.base.regular',
                fontSize: 'fontsize.xs',
              }}
            />
            <VStack space={Spacing['stack.quarck']}>
              <UI.Text color="neutral.darkest" variant="semibold">
                Produto
              </UI.Text>
              <UI.Text textTransform="uppercase">{product.marketNameNormalized}</UI.Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between">
            <UI.Text color="neutral.dark" variant="semibold">
              TOTAL
            </UI.Text>
            <UI.Text variant="semibold">{Utils.Mask.Money(product.valueNormalized)}</UI.Text>
          </HStack>
        </VStack>
      </UI.Shadow>
    );
  }

  return (
    <UI.ProductCard
      loading={false}
      size={60}
      testId={product.marketNameNormalized}
      color={product.colorNormalized}
      product={{
        name: product.marketNameNormalized,
        percentage: product.percentageNormalized,
        value: product.valueNormalized,
      }}
      rightComponent={
        <HStack pl={Spacing['inline.nano']} space={Spacing['inline.nano']} alignItems="center">
          <UI.Icon name="Calendar" size="xxxs" color={Color['neutral.medium']} />
          <UI.Text color={'neutral.medium'} fontSize="sm">
            Atualizado em {Utils.Mask.DateFormat(selectedDate || new Date(), 'dd/MM/yyyy')}
          </UI.Text>
        </HStack>
      }
    />
  );
};
